import {Mapper} from '@s-ui/domain'

export default class PaymentMethodsCheckoutRawDataToPaymentMethodsCheckoutVOMapper extends Mapper {
  constructor({valueObject}) {
    super()
    this._valueObject = valueObject
  }

  map = rawPaymentMethods => this._valueObject({...rawPaymentMethods})
}
